<script setup>
const text = `For persons with disability, please visit the nearest subcounty revenue office with your
                National Council For Persons Living With Disabilities <abbr>(NCPLWD)</abbr> registration details to be
                assisted.`
</script>

<template>
    <div>
        <div v-if="$mobileBreakpoint">
            <v-card outlined>
                <v-card-text v-html="text">

                </v-card-text>
            </v-card>
        </div>
        <div v-else class="d-flex align-center">
            <div class="text-body-2">Persons with disability?</div>

            <v-tooltip top max-width="600">
                <template #activator="{ on, attrs }">
                    <v-icon class="ml-4" color="secondary" v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                </template>
                <span v-html="text">
                </span>
            </v-tooltip>
        </div>
    </div>
</template>